import { useEffect, useState, useCallback } from "react";

const KEY = "phizo-theme";

export function applyTheme(mode) {
  const root = document.documentElement;
  if (mode === "dark") root.classList.add("dark");
  else root.classList.remove("dark");
}

// Initialise ASAP so app doesn't flash light.
export function initTheme() {
  const saved = localStorage.getItem(KEY);
  applyTheme(saved === "dark" ? "dark" : "light");
}

export function useTheme() {
  const [mode, setMode] = useState(() =>
    (typeof window !== "undefined" && localStorage.getItem(KEY) === "dark")
      ? "dark" : "light"
  );

  useEffect(() => {
    applyTheme(mode);
    try { localStorage.setItem(KEY, mode); } catch (e) { if (process.env.NODE_ENV !== "production") console.debug("theme persist:", e); }
  }, [mode]);

  const toggle = useCallback(() => setMode((m) => (m === "dark" ? "light" : "dark")), []);
  return { mode, setMode, toggle, isDark: mode === "dark" };
}
